export function AccessPrevilegesFunction(previlage) {
    const currentUserPrevilages = JSON.parse(localStorage.getItem('user'))?.profile?.access_privilages || [];
    return currentUserPrevilages.includes(previlage);
}
